// chains/chains.ts
import { rinkeby, mainnet } from "wagmi/chains";
var avalandche = {
  id: 43114,
  name: "Avalanche C-Chain",
  network: "avalanche",
  rpcUrls: {
    default: "https://rpc.ankr.com/avalanche"
  },
  nativeCurrency: { name: "Avalanche", symbol: "AVAX", decimals: 18 },
  blockExplorers: {
    default: {
      name: "snowtrace",
      url: "https://snowtrace.io/"
    }
  }
};
var avalandcheFuji = {
  id: 43113,
  name: "Avalanche Fuji",
  network: "avalanche-fuji",
  rpcUrls: {
    default: "https://rpc.ankr.com/avalanche_fuji"
  },
  nativeCurrency: { name: "Avalanche", symbol: "AVAX", decimals: 18 },
  blockExplorers: {
    default: {
      name: "snowtrace",
      url: "https://testnet.snowtrace.io/"
    }
  },
  testnet: true
};
var fantomOpera = {
  id: 250,
  name: "Fantom Opera",
  network: "fantom",
  nativeCurrency: { name: "Fantom", symbol: "FTM", decimals: 18 },
  rpcUrls: {
    default: "https://rpc.ftm.tools"
  },
  blockExplorers: {
    default: {
      name: "FTMScan",
      url: "https://ftmscan.com"
    }
  }
};
var fantomTestnet = {
  id: 4002,
  name: "Fantom Testnet",
  network: "fantom-testnet",
  nativeCurrency: { name: "Fantom", symbol: "FTM", decimals: 18 },
  rpcUrls: {
    default: "https://rpc.testnet.fantom.network"
  },
  blockExplorers: {
    default: {
      name: "FTMScan",
      url: "https://testnet.ftmscan.com"
    }
  },
  testnet: true
};
var bscExplorer = { name: "BscScan", url: "https://bscscan.com/" };
var bsc = {
  id: 56,
  name: "Binance Smart Chain",
  network: "bsc",
  rpcUrls: {
    public: "https://bsc-dataseed1.binance.org",
    default: "https://bsc-dataseed1.binance.org"
  },
  blockExplorers: {
    default: bscExplorer,
    etherscan: bscExplorer
  },
  nativeCurrency: {
    name: "Binance Smart Chain",
    symbol: "BNB",
    decimals: 18
  },
  multicall: {
    address: "0x0DA63Aa4c53D996a71C9b398B7E0f97c99d9EC53",
    blockCreated: 25269370
  }
};
var bscTest = {
  id: 42161,
  name: "Arbitrum One",
  network: "Ethereum",
  nativeCurrency: {
    decimals: 18,
    name: "Arbitrum One",
    symbol: "ETH"
  },
  rpcUrls: {
    public: "https://arb-mainnet.g.alchemy.com/v2/JQ5hBJw4XJXDkr0uV3TYP-magh75B9kX",
    default: "https://arb-mainnet.g.alchemy.com/v2/JQ5hBJw4XJXDkr0uV3TYP-magh75B9kX"
  },
  blockExplorers: {
    default: { name: "ArbiScan", url: "https://arbiscan.io/" }
  },
  multicall: {
    address: "0x5D3fdA092e270F48DfE34b3fe00C484c68BAA95D",
    blockCreated: 87973703
  },
  testnet: true
};
var goerli = {
  id: 421613,
  name: "Arbitrum Testnet",
  network: "Arbitrum",
  nativeCurrency: {
    decimals: 18,
    name: "Arbitrum Testnet",
    symbol: "AETH"
  },
  rpcUrls: {
    public: "https://goerli-rollup.arbitrum.io/rpc",
    default: "https://goerli-rollup.arbitrum.io/rpc"
  },
  blockExplorers: {
    default: { name: "ArbiScan", url: "https://testnet.arbiscan.io" }
  },
  multicall: {
    address: "0x80a804EAa238770a7f853e3222cC3D69213F9a14",
    blockCreated: 12300629
  },
  testnet: true
};
export {
  avalandche,
  avalandcheFuji,
  bsc,
  bscTest,
  fantomOpera,
  fantomTestnet,
  goerli,
  mainnet,
  rinkeby
};
